import { Button, DataSource, Layout, SearchButton, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAvailableLoadsList extends Layout {
    buttonBlastOffer: Button;
    buttonSendAvailableEmail: Button;
    searchbuttonSearch: SearchButton;
    sourceAvailableLoads: DataSource;
    sourcePnnControl: DataSource;
    tableAvailableLoads: Table;
    textboxCarrier: Textbox;
    textboxDateRange: Textbox;
    textboxDefaultContact: Textbox;
    textboxE: Textbox;
    textboxEmail: Textbox;
    textboxPhone: Textbox;
}
